import type { RouteObject } from "react-router-dom";
import { Navigate, useParams } from "react-router-dom";
import { DashboardPage } from "@/modules/dashboard/pages/DashboardPage";
import { useLocale } from "@seller/app/locale";

function SellerDashboardRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();

  return <DashboardPage locale={locale} storeSlug={storeSlug} />;
}

export const dashboardRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="orders" replace />,
  },
  {
    path: "dashboard",
    element: <SellerDashboardRoute />,
  },
];
